import * as React from 'react';
import { Table } from 'antd';
import Flag from "react-flags";
import { getRecords, IRecordScore } from '../api';
import { AimScoresBox } from './AimRecords.css';
import { displayDate } from '../../../../../games/functions';

const tColumns = [
    {
        title: 'User',
        dataIndex: 'name',
        render: (name: string, record: IRecordScore) => <>
            <Flag name={record.countryCode} shiny={true} basePath="img/" format="png" pngSize={24} /> {name}
        </>
    },
    {
        title: 'Score',
        dataIndex: 'level',
    },
    {
        title: 'Date',
        dataIndex: 'date',
        render: (date: string) => displayDate(date),
    }
]

const AimRecords = (props: { gameId: number }) => {
    const {gameId} = props;
    const {useState, useEffect} = React;
    const [userScores, setUserScores] = useState<IRecordScore[]>([]);

    useEffect(() => {
        (async function() {
            const scores = await getRecords(gameId);
            setUserScores(scores);
        })();
    }, []);

    return (
        <AimScoresBox>
            <Table columns={tColumns} dataSource={userScores} pagination={false} />
        </AimScoresBox>
    );
};

export default AimRecords;